import { render, staticRenderFns } from "./CustomerSelectionWishlist.vue?vue&type=template&id=fcb64a06&"
import script from "./CustomerSelectionWishlist.vue?vue&type=script&lang=js&"
export * from "./CustomerSelectionWishlist.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSelectionWishlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports